import Vue from "vue";

Vue.use({
  install() {
    Vue.prototype.$suspended = function(slug) {
      if (this.$route.name !== 'alerts.index') {
        this.$store.dispatch("local/set", { key: "login", value: true });
        this.$store.dispatch("local/set", { key: "redirect-route", value: slug });
      }
    };
  }
});



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/suspended.js